import React from "react";
import EditAutomaticReleaseCreationPage from "./EditAutomaticReleaseCreationPage";
interface CreateBuiltInFeedTriggerPageProps {
    spaceId: string;
    projectSlug: string;
}
export function CreateBuiltInFeedTriggerPage({ spaceId, projectSlug }: CreateBuiltInFeedTriggerPageProps) {
    return <EditAutomaticReleaseCreationPage create={true} spaceId={spaceId} projectSlug={projectSlug}/>;
}
